module.exports = __webpack_public_path__ + "static/media/19.b5e36e35.png";